import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Calendar as CalendarPicker } from "@/components/ui/calendar";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toISODate, parseISODate } from "@/lib/time";
import { useTranslation } from "@/i18n";

export default function GoToDateDialog({ open, onOpenChange, initialDate }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selected, setSelected] = useState(() =>
    initialDate ? parseISODate(initialDate) : new Date()
  );

  const go = () => {
    const iso = toISODate(selected || new Date());
    onOpenChange(false);
    navigate(`/calendar/${iso}`);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm rounded-2xl" data-testid="goto-date-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">{t("goToDate.title")}</DialogTitle>
        </DialogHeader>
        <div className="flex justify-center">
          <CalendarPicker
            mode="single"
            selected={selected}
            onSelect={(d) => d && setSelected(d)}
            initialFocus
            data-testid="goto-date-calendar"
          />
        </div>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            className="rounded-full"
            onClick={() => onOpenChange(false)}
            data-testid="goto-date-cancel"
          >
            {t("goToDate.cancel")}
          </Button>
          <Button
            className="rounded-full"
            onClick={go}
            data-testid="goto-date-confirm"
          >
            {t("goToDate.openDay")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
